import moment from 'moment-timezone';

export class BrowserUtils {

  public static getBrowserTimezone(): string {
    return moment.tz.guess();
  }

  public static isMobile(): boolean {
    // MDN recommended on how to test if the current browser is for mobiles
    return !!window.navigator.userAgent.match(/Mobi/);
  }

  public static isTextSelected(): boolean {
    return !!(window.getSelection()?.toString());
  }

  public static copyToClipboard(val: string): void {
    /* execCommand is deprecated, and to avoid using it, window.navigator must be used.
    However, this requires a secure context (https). For development environments where https is
    not always available, we are maintaining the use of document.execCommand('copy') here.*/
    if (window.isSecureContext) {
      window.navigator.clipboard.writeText(val).then(() => {});
    } else {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }
  }

}
